import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function TreatsGridConsumer() {
  const {
    products,
    loading,
    error,
    refetch
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="space-y-4">
            <div className="aspect-square rounded-lg bg-muted animate-pulse" />
            <div className="h-4 w-20 bg-muted animate-pulse rounded-md" />
            <div className="h-6 w-3/4 bg-muted animate-pulse rounded-md" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-sm text-muted-foreground">
        Unable to load travel packages.{" "}
        <Button variant="link" onClick={refetch} className="p-0 h-auto underline">
          Retry
        </Button>
      </div>;
  }
  if (products.length === 0) {
    return <p className="text-muted-foreground font-default italic text-lg">
        Our travel packages are being curated.
      </p>;
  }
  const formatIndex = (i: number) => String(i + 1).padStart(2, "0");
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-16">
      {products.map((product, i) => {
      const categoryName = product.categories && product.categories.length > 0 ? product.categories[0].name : "DESTINATION";
      return <article data-index={i} key={product.id} className="group relative flex flex-col">
            <div className="absolute -top-2 -left-1 z-10 font-mono text-xs tracking-widest text-primary">
              {formatIndex(i)}
            </div>

            <Link to={product.link} className="block">
              <div className="relative aspect-square overflow-hidden rounded-lg bg-card shadow-md">
                {product.featured_image_url && <img src={product.featured_image_url} alt={product.title} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />}
              </div>
            </Link>

            <div className="mt-6 flex flex-col">
              <span className="font-default text-[11px] tracking-[0.2em] text-secondary uppercase font-semibold">
                — {categoryName}
              </span>

              <div className="mt-2 flex items-start justify-between gap-4">
                <Link to={product.link} className="block flex-1">
                  <h3 className="font-default font-semibold text-[22px] leading-tight text-foreground">
                    {product.title}
                  </h3>
                </Link>
                <span className="font-default text-base text-foreground shrink-0 pt-1">
                  R{typeof product.price === "number" ? product.price.toFixed(2) : product.price}
                </span>
              </div>

              <div className="mt-5 relative">
                <AddToCartButton productId={product.id} variant="link" className="w-full" buttonClassName="bg-primary text-primary-foreground rounded-lg" text="Book Now" showQuantity={false} />
              </div>
            </div>
          </article>;
    })}
    </div>;
}
export default function DestinationTabs() {
  const wp_query_params = {
    per_page: 4,
    post_type: "product"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="2202" id="destinationproducttabs" className="bg-background text-foreground py-24 md:py-32 lg:py-40">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-20 lg:mb-28">
          <div className="lg:col-span-7">
            <p className="font-default text-xs tracking-[0.25em] text-secondary uppercase mb-8 font-bold">
              02 — Featured Escapes
            </p>
            <h2 className="font-default font-bold text-4xl sm:text-5xl lg:text-6xl xl:text-[68px] leading-[1.05] text-foreground tracking-tight">
              Handpicked journeys,{" "}
              <em className="italic font-normal text-primary">
                crafted for
              </em>{" "}
              your next adventure.
            </h2>
          </div>

          <div className="lg:col-span-5 lg:col-start-8 flex flex-col justify-end">
            <p className="font-default text-base lg:text-lg leading-relaxed text-foreground/80 mb-8">
              From sun-drenched beaches to mountain retreats, our experts 
              curate every detail. Experience seamless booking and unforgettable 
              memories with our exclusive holiday packages.
            </p>
            <Link to="/ShopPage" className="group inline-flex items-center gap-2 font-default text-xs tracking-[0.2em] uppercase text-primary border-b border-primary/40 pb-2 w-fit hover:border-primary transition-colors">
              <span>View All Packages</span>
              <ArrowRight className="size-3.5 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        post_type: "product"
      }}>
          <TreatsGridConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}